<template>
  <section class="container px-4 xl:px-0 font-sf-pro">
    <div class="text-xl lg:text-4xl font-bold mb-3 lg:mb-5 font-sf-pro text-gray-900">Адрес</div>
    <div class="w-full h-46 lg:h-106 rounded-[24px] roundedIOS overflow-hidden mb-3">
      <yandex-map
        v-if="isMounted"
        :coordinates="coords"
        :zoom="18"
        :center="coords"
        class="h-46 lg:h-107 w-full"
      >
        <yandex-marker
          :coordinates="coords"
          :marker-id="123"
          :hint-content="data.place.description"
        />
      </yandex-map>
    </div>
    <!-- <div class="text-sm mb-2 font-sf-pro text-gray-300">Театр</div> -->
    <div class="text-lg mb-1 font-sf-pro font-medium text-gray-900">
      {{ data.place.name }}
    </div>
    <div class="flex flex-col-reverse sm:flex-row gap-1 sm:gap-4">
      <div class="text-sm font-sf-pro text-primary-100">
        {{ data.place.address }}
      </div>
      <div class="text-sm font-sf-pro text-gray-300">
        {{ data.place.contacts.tel }}
      </div>
    </div>
  </section>
</template>

<script>
import { YandexMap, YandexMarker } from 'vue-yandex-maps'
export default {
  components: { YandexMap, YandexMarker },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    coords: [],
    isMounted: false
  }),
  mounted() {
    this.coords = [this.data.place.coordinates.longitude, this.data.place.coordinates.latitude]
    this.isMounted = true
  },
  watch: {
    data() {
      this.isMounted = false
      this.coords = [this.data.place.coordinates.longitude, this.data.place.coordinates.latitude]
      this.isMounted = true
    }
  },
  methods: {}
}
</script>

<style scoped>
#app {
  width: 100%;
  height: 100vh;
}

.ymap-container {
  height: 100%;
}

.roundedIOS {
  -webkit-border-radius: 24px;
  -moz-border-radius: 24px;
}
</style>
